import { render, staticRenderFns } from "./LEmptyState.vue?vue&type=template&id=108abcc4&scoped=true"
import script from "./LEmptyState.vue?vue&type=script&lang=ts"
export * from "./LEmptyState.vue?vue&type=script&lang=ts"
import style0 from "./LEmptyState.vue?vue&type=style&index=0&id=108abcc4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108abcc4",
  null
  
)

export default component.exports